import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import './style.scss';
import Video from './movie/background.mp4';
import Image from './image/agsafebk.png';
import Linkedin from './image/linkedin.png';
import Instagram from './image/instagram.png';
import Button from '../../components/button/index.tsx';

function Landing() {
  const [showMovieBackground, setshowMovieBackground] = useState(true);
  const history = useHistory();
  let video = null;

  function playMovie() {
    try {
      video = document.getElementById('background-video').play();
    } catch (error) {}
  }

  useEffect(() => {
    if (window.screen.width < 640 || window.screen.width < 480) {
      setshowMovieBackground(false);
    } else if (window.screen.width < 1024 || window.screen.width < 768) {
      playMovie();
      setshowMovieBackground(true);
    } else {
      playMovie();
      setshowMovieBackground(true);
    }
  }, [showMovieBackground]);

  function clicarInstagram() {
    window.open('https://www.instagram.com/agsafeapp/', '_blank');
  }

  function clicarLinkedin() {
    window.open('https://www.linkedin.com/company/agsafeapp/', '_blank');
  }

  return (
    <section id="main-landin-page" className="main">
      {showMovieBackground
        ? <video src={Video} autoPlay muted loop id="background-video" />
        : <section className="backgroundImage" />}

      <section className="conteudo-geral content-box">

        <section className="cima">
          <img src={Image} alt="Logo" />
        </section>

        <section className="meio">
          <span className="titulo">-Estou aqui ! Por favor tenha cuidado.-</span>
          <span className="sub-titulo">#I’m here! Please be careful.</span>
          <Button type="button" className="signup" onClick={() => history.push('/dashboard')}> Cadastre-se agora </Button>
        </section>

        <section className="baixo">
          <section className="redes-sociais">
            <button type="button" onClick={clicarLinkedin} id="linkedin">
              <img src={Linkedin} alt="Linkedin" />
              <span>Linkedin</span>
            </button>

            <button type="button" onClick={clicarInstagram} id="instagram">
              <img src={Instagram} alt="Instagram" />
              <span>Instagram</span>
            </button>
          </section>

          <section className="copyright">
            <span>Copyright ⓒ 2021 AGSAFE</span>
          </section>

        </section>

      </section>

    </section>
  );
}

export default Landing;
